"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataFilter = void 0;
var React = __importStar(require("react"));
var models_1 = require("../../models");
/** Filters a data set against a string given a filter function. */
var useDataFilter = function (data, search, filterFunction, callback) {
    var _a = React.useState(data), filteredData = _a[0], setFilteredData = _a[1];
    React.useEffect(function () {
        if (filterFunction && search !== undefined && data) {
            window.console.log("useDataFilter - something changed so we are running!");
            var filtered = new models_1.Grouping("", data).filter(function (d) { return filterFunction(d, search); }, function (g) { return g.children.length > 0; });
            setFilteredData(filtered ? filtered.children : []);
        }
        else {
            setFilteredData(data);
        }
    }, [data, search, filterFunction]);
    React.useEffect(function () {
        if (callback) {
            callback(filteredData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredData]);
};
exports.useDataFilter = useDataFilter;
